import React, { useEffect, useState, useRef } from "react";
import { Col, Card, Table, Alert, Spinner, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
function SolvedMenuReviews() {
  var history = useHistory();
  const sort = 10;
  const activePag = useRef(0);
  const [reviews, setReviews] = useState([]);
  const [data, setData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [spinner, setSpinner] = useState(true);
  const [show, setShow] = useState(false);
  const [test, settest] = useState(0);
  function getData(length) {
    axios
      .get(Baseurl.baseurl4 + `/go-food/get-all-menu-review/${length}`)
      .then((res) => {
        console.log("not verified", res.data.data);
        setSpinner(false);
        if(res.data.status){
            setReviews(res.data.data);
            setSearchData(res.data.data);
            setData(document.querySelectorAll("#job_data tbody tr"));
        }else {
          swal("No More Data", "", "error", {
            button: "Done",
            timer: 1000,
          });
        }
       
      })
      .catch((err) => {
       
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    settest(i);
  };

  useEffect(() => {
    getData(reviews.length);
  }, []);

 

  function searchRider(value) {
    let filteredData = [];
    if (searchData) {
      searchData.map((val) => {
        let phoneString = val.riderPhone.toString();
        if (
          val.riderFirstName.toLowerCase().includes(value) ||
          val.riderLastName.toLowerCase().includes(value) ||
          val.riderEmail.toLowerCase().includes(value) ||
          phoneString.includes(value)
        ) {
          filteredData.push(val);
        }
      });
      setReviews(filteredData);
    }
  }
  
  function solveIssue(id){
      axios
        .put(`${Baseurl.baseurl4}/go-food/solve-menu-review/${id}`)
        .then((res) => {
          if (res.data.status) {
            swal("Solved", res.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
            getData(reviews.length);
          } else {
            swal("Oops", res.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }
        })
        .catch((err) => {
         
        });
  }
  return (
    <Col lg={12}>
      <Modal
        size="lg"
        show={show}
        onHide={() => {
          setShow(false);
        }}
      >
        <Modal.Body>
          <h4>Are You sure !! you want to block the owner ?</h4>
        </Modal.Body>
        <Modal.Footer>
        
        </Modal.Footer>
      </Modal>
      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <div>
            <input
              type="text"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
                searchRider(e.target.value);
              }}
            />
          </div>
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white text-sm" responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>SL NO.</strong>
                    </th>

                    <th>
                      <strong> Date</strong>
                    </th>
                    <th>
                      <strong>Issue</strong>
                    </th>
                    <th>
                      <strong>Title</strong>
                    </th>

                    <th>
                      <strong>Status</strong>
                    </th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {reviews &&
                    reviews.map((val, key) => (
                      <tr key={val._id}>
                        <td>{key + 1}</td>
                        <td>{val.Date}</td>
                        <td>{val.Issue}</td>
                        <td>{val.Title}</td>
                        <td>{val.Solved ? "Solved" : "Un-Solved"}</td>
                        {!val.Solved && (
                          <td>
                            <button
                              onClick={() => {
                               solveIssue(val._id)
                              }}
                              className="btn btn-primary"
                            >
                              Solve
                            </button>
                          </td>
                        )}
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}
            {!reviews && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero reviews
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
                <button
                  onClick={() => {
                    getData(reviews.length);
                  }}
                  className="btn btn-primary ml-2"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default SolvedMenuReviews;
